export { ScrollAreaContext } from './scroll-area-context.js';
export { ScrollAreaContent } from './scroll-area-content.js';
export { ScrollAreaCorner } from './scroll-area-corner.js';
export { ScrollAreaRoot } from './scroll-area-root.js';
export { ScrollAreaRootProvider } from './scroll-area-root-provider.js';
export { ScrollAreaScrollbar } from './scroll-area-scrollbar.js';
export { ScrollAreaThumb } from './scroll-area-thumb.js';
export { ScrollAreaViewport } from './scroll-area-viewport.js';
export { useScrollArea } from './use-scroll-area.js';
export { useScrollAreaContext } from './use-scroll-area-context.js';
import * as scrollArea from './scroll-area.js';
export { scrollArea as ScrollArea };
export { anatomy as scrollAreaAnatomy } from '@zag-js/scroll-area';
